import ListQueryFunctionGenerator from "./ListQueryFunctionGenerator";
import { RawDocument } from "@/model/Document";

// prettier-ignore
const ENDPOINT = (shipmentId: string) => `shipments/${shipmentId}/documents`;

export default ListQueryFunctionGenerator<RawDocument[]>(ENDPOINT, {
  addIdsOfRelationshipsToResult: ["section"],
});
